import useRequest from '@/websdk/utils/request';

export default (function (param) {
  const { isRequestSuccessed, data, exec } = useRequest({
    url: '/api/simple_products',
    name: 'GET_SIMPLE_PRODUCT_LIST',
    method: 'GET',
  });

  return [data || [], exec, isRequestSuccessed];
});
